import React from "react";
import {
  BookinPanelContainer,
  BookingDates,
  DateTitle,
  Dates,
  CapitalizeString,
  BookingTimes,
  FieldWrapper,
  ConfirmButtonContainer
} from "./styled";
import Select from "../common/FieldSelect";
import ConfirmCounter from "../common/ConfirmCounter";
import { useForm, Controller } from "react-hook-form";
import {
  FormTypes,
  FORM_NAMES,
  MIN_INPUT_NUMBERS,
  MAX_INPUT_NUMBERS,
} from "./types";
import { useReservation } from "../../context/reservation";
import whiteArrowRight from "../../assets/icons/arrowNext.svg";
import { HOURS24 } from "../../utils/constants";
import Button from "../common/Buttons";
import {PATHS} from '../../Routes';
import { useHistory } from "react-router-dom";

type BookingPanelInfoProps = {
  checkInDate: string;
  checkOutDate: string;
};

const defaultProps: BookingPanelInfoProps = {
  checkInDate: "",
  checkOutDate: "",
};

function BookingPanelInfo({
  checkInDate,
  checkOutDate,
}: BookingPanelInfoProps) {
  const { data: reservation } = useReservation();
  const numberOfGuests = reservation?.guest_group?.number_of_guests;
  const initChildrenNumber = MIN_INPUT_NUMBERS[FORM_NAMES.children];
  const history = useHistory();
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    trigger,
    formState,
    control,
  } = useForm<FormTypes>({
    defaultValues: {
      [FORM_NAMES.numberOfGuests]: numberOfGuests,
    },
    shouldFocusError: false,
  });
  const {errors} = formState;
  React.useEffect(() => {
    register(FORM_NAMES.numberOfGuests, {
      required: "Required",
      validate: (value) => {
        if (Number(value) < MIN_INPUT_NUMBERS.number_of_guests) {
          return `Min number is ${MIN_INPUT_NUMBERS.number_of_guest}`;
        }
        if (Number(value) > MAX_INPUT_NUMBERS.number_of_guests) {
          return `Max number is ${MAX_INPUT_NUMBERS.number_of_guest}`;
        }
      },
    });

    register(FORM_NAMES.children, {
      required: "Required",
      validate: (value) => {
        if (Number(value) < MIN_INPUT_NUMBERS.children) {
          return `Min number is ${MIN_INPUT_NUMBERS.children}`;
        }
        if (Number(value) > MAX_INPUT_NUMBERS.children) {
          return `Max number is ${MAX_INPUT_NUMBERS.children}`;
        }
      },
    });
    setValue(FORM_NAMES.children, initChildrenNumber);
    setValue(FORM_NAMES.numberOfGuests, numberOfGuests);
  }, [register, setValue, initChildrenNumber, numberOfGuests]);

  const handleInputDecrement = async (name: FORM_NAMES) => {
    const value = watch(name);
    const minNumber = MIN_INPUT_NUMBERS[name] || 0;

    if (Number(value) - 1 < minNumber) {
      setValue(name, 0);
      // await revalidateFormField();
      return;
    }

    setValue(name, Number(watch(name)) - 1);
    // await revalidateFormField();
  };

  const handleInputIncrement = async (name: FORM_NAMES) => {
    const value = watch(name);
    const minNumber = MIN_INPUT_NUMBERS[name] || 0;
    const maxNumber = MAX_INPUT_NUMBERS[name];

    if (Number(value) + 1 < minNumber) {
      setValue(name, 0);
      // await revalidateFormField();
      // return;
    }

    if (Number(value) + 1 > maxNumber) {
      setValue(name, maxNumber);
      // await revalidateFormField();
      // return;
    }

    setValue(name, Number(watch(name)) + 1);
    // await revalidateFormField();
  };
  const checkInDateFormat = new Date(Date.parse(checkInDate));
  const checkOutDateFormat = new Date(Date.parse(checkOutDate));
  const monthNames = [
    "january",
    "february",
    "march",
    "april",
    "may",
    "june",
    "july",
    "august",
    "september",
    "october",
    "november",
    "december",
  ];

  const checkInDay = checkInDateFormat.getDate();
  const checkInMonth = checkInDateFormat.getMonth();

  const checkOutDay = checkOutDateFormat.getDate();
  const checkOutMonth = checkOutDateFormat.getMonth();
  const checkOutYear = checkOutDateFormat.getFullYear();

  const onSubmit = React.useCallback(
    (data: FormTypes) => {
      console.log(data)
      history.push(PATHS.IVDocumentSelection);
      // const state = getPersistedState(data);
      // IdGuestAppEvents(MIXPANEL_EVENTS_NAME.confirmed);
      // if (hasBiomatchForGuestLeader || hasBiomatchForAllGuests) {
      //   return history.push(PATHS.verificationStart, state);
      // }
      // history.push(PATHS.formPersonalData, state);
    },
    [history],
  );

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <BookinPanelContainer>
        <BookingDates>
          <DateTitle>Dates:</DateTitle>
          <Dates>
            <CapitalizeString>{monthNames[checkInMonth]} </CapitalizeString>
            {checkInDay}-
            <CapitalizeString>{monthNames[checkOutMonth]} </CapitalizeString>
            {checkOutDay}, {checkOutYear}
          </Dates>
        </BookingDates>
        <BookingTimes>
          <FieldWrapper>
            <Controller
              name={FORM_NAMES.timeArrival}
              rules={{ required: true }}
              control={control}
              render={({ field, fieldState: { error } }) => (
                <Select
                  options={HOURS24}
                  error={error?.message}
                  label={"arrival_time"}
                  {...field}
                />
              )}
            />
          </FieldWrapper>
          <FieldWrapper>
            <Controller
              name={FORM_NAMES.timeLeave}
              rules={{ required: true }}
              control={control}
              render={({ field, fieldState: { error } }) => (
                <Select
                  options={HOURS24}
                  error={error?.message}
                  label={"leaving_time"}
                  {...field}
                />
              )}
            />
          </FieldWrapper>
        </BookingTimes>
        <ConfirmCounter
          title={"Arrival"}
          onDecrement={() => handleInputDecrement(FORM_NAMES.numberOfGuests)}
          onIncrement={() => handleInputIncrement(FORM_NAMES.numberOfGuests)}
          value={watch(FORM_NAMES.numberOfGuests)}
          error={errors?.[FORM_NAMES.numberOfGuests]?.message}
        />
        <ConfirmCounter
          title={"children"}
          //subtitle={'under_number'}  el numero que va aca, es la edad minima por pais. este es un campo que tiene que traer el backend
          onDecrement={() => handleInputDecrement(FORM_NAMES.children)}
          onIncrement={() => handleInputIncrement(FORM_NAMES.children)}
          value={
            watch(FORM_NAMES.children) === undefined
              ? initChildrenNumber
              : watch(FORM_NAMES.children)
          }
          // error={errors?.children?.message as string}
        />
        <ConfirmButtonContainer>
          <Button
            rounded
            primary
            label={"Confirm Details"}
            iconRight={whiteArrowRight}
            width={"250px"}
            type={'submit'}
          />
        </ConfirmButtonContainer>
      </BookinPanelContainer>
    </form>
  );
}

BookingPanelInfo.defaultProps = defaultProps;

export { BookingPanelInfo };
